module Widgets.Form.StudentSubForm where

import Common

import Concur.React.DOM as D
import Concur.React.Props as P
import Data.Maybe (maybe)
import Widgets.Form.Class (class FormWidget, getData, fieldPaths, setData, toWidget)
import Widgets.Form.SubForm (SubForm(..))
import API.SelStudent (studentName)


data StudentSubForm = StudentSubForm SubForm

instance showStudentSubForm :: Show StudentSubForm where
      show (StudentSubForm sf) = show sf

instance stsfFW :: FormWidget StudentSubForm where
    getId (StudentSubForm (SubForm { id })) = id
    asField _ = Nothing
    isLeaf _ = false
    fieldPaths fc (StudentSubForm state) = fieldPaths fc state

    toWidget fc (StudentSubForm state) = wrapResult <$> D.div
        [ P.className "student-subform" ]
        [ D.h2' [ D.text name ]
        , toWidget fc state
        ]
      where
        name = maybe "NO DOCUMENT SET - STUDENT NAME UNKNOWN"
            (studentName fc.account <<< _.student) fc.doc
        wrapResult r = StudentSubForm <$> r

    getData fc (StudentSubForm state) = getData fc state
    setData fc (StudentSubForm state) json = do
        newsf <- setData fc state json
        pure $ StudentSubForm newsf
